import React from 'react';
import { Modal, Checkbox, DatePicker } from 'antd';
import moment from 'moment';
import { serviceTracker_allowed } from '../../config.js';
const CheckboxGroup = Checkbox.Group;


class ModalUsers extends React.Component {

  constructor() {
    super();
    this.state = {
      first: '',
      last: '',
      grade: '',
      email: '',
      birth: '1/1/2000',
      id: '',
      customId: '',
      products: '',
      savedProduct: null
    }
  }

  updateData = () => {
    if (this.props.type == 'student' && this.props.mode == 'edit') {
      this.setState({
        first: this.props.data.first,
        last: this.props.data.last,
        grade: this.props.data.grade,
        email: this.props.data.email,
        birth: moment(this.props.data.birth, 'DD-MM-YYYY'),
        id: this.props.data.id,
        customId: this.props.data.customId,
        products: this.props.data.products,
        savedProduct: this.props.data.products
      })
    } else if (this.props.mode == 'edit') {
      this.setState({
        first: this.props.data.first,
        last: this.props.data.last,
        email: this.props.data.email,
        id: this.props.data.id,
        customId: this.props.data.customId,
        products: this.props.data.products,
        savedProduct: this.props.data.products
      })
    }
  }

  cancel = () => {
    this.setState({
      first: '',
      last: '',
      grade: '',
      email: '',
      id: '',
      customId: '',
      products: '',
      savedProduct: ''
    }, () => { this.props.cancel() }
    )
  }

  onChangeCheckbox = (checkedValues) => {
    this.setState({ products: checkedValues })
  }
  save = () => {
    let data = {}
    if (this.props.type == 'student') {
      data = {
        first: this.state.first,
        last: this.state.last,
        grade: this.state.grade,
        email: this.state.email,
        birth: this.state.birth,
        id: this.state.id,
        customId: this.state.customId,
        products: this.state.products,
        savedProduct: this.state.savedProduct
      }
    } else {
      data = {
        first: this.state.first,
        last: this.state.last,
        email: this.state.email,
        id: this.state.id,
        customId: this.state.customId,
        products: this.state.products,
        savedProduct: this.state.savedProduct
      }
    }
    this.props.save(data, this.props.mode)
  }

  render() {
    const t = this.props.t
    const productOptions = [
      {label: 'SkillTracker' ,value: 'SkillTracker', disabled: this.props.products && !this.props.products.includes('SkillTracker')},
      {label: 'ServiceTracker' ,value: 'ServiceTracker', disabled: this.props.products && !this.props.products.includes('ServiceTracker')},
    ];
    return (
      <div>
        <Modal
          className="edituser"
          visible={this.props.open}
          onOk={this.save}
          onCancel={this.cancel}
          okText={t('Ok')}
          cancelText={t('Cancel')}
        >
          {this.props.type == 'student' ?
            <h3>{t('Student ID')}</h3>
            :
            <h3>{t('Teacher ID')}</h3>
          }
          <input type="text" value={this.state.customId} onChange={(e) => this.setState({ customId: e.target.value })} />
          <h3>{t('First Name')}</h3>
          <input type="text" value={this.state.first} onChange={(e) => this.setState({ first: e.target.value })} />
          <h3>{t('Last Name')}</h3>
          <input type="text" value={this.state.last} onChange={(e) => this.setState({ last: e.target.value })} />
          {this.props.type == 'student' &&
            <div>
              <h3>{t('Grade')}</h3>
              <input type="number" value={this.state.grade} onChange={(e) => this.setState({ grade: e.target.value })} />
            </div>
          }
          {serviceTracker_allowed &&
            <div>
              <h3>{t('Products')}</h3>
              <div>
                <CheckboxGroup options={productOptions} value={this.state.products} onChange={(e) => this.onChangeCheckbox(e)} />
                <br /><br />
              </div>
          </div>
          }
          <h3>{t('Email Address')}</h3>
          <input type="email" value={this.state.email} onChange={(e) => this.setState({ email: e.target.value })} />
          {this.props.type == 'student' &&
            <div>
              <h3>{t('Birth Date')}</h3>
              <DatePicker
                allowClear={false}
                format={'DD-MM-YYYY'}
                value={moment(this.state.birth, 'DD-MM-YYYY')}
                onChange={(date) => this.setState({ birth: date })}
              />
            </div>
          }
        </Modal>
      </div>
    )
  }
}

export default ModalUsers;



// WEBPACK FOOTER //
// ./src/components/ModalUsers/index.jsx